/**
 * Fallback de TEA cuando el backend no envía el valor.
 * El flujo normal obtiene `tea` desde GET /vida/prestamos/polizas (configuracion PRESTAMOS_VIDA/TEA).
 */
export const TEA_PRESTAMO_VIDA_DISPLAY = ''

function parseValorTasa (valorApi) {
  if (valorApi === null || valorApi === undefined || valorApi === '') return NaN
  const normalizado = String(valorApi).replace(/,/g, '').trim()
  return parseFloat(normalizado)
}

/**
 * Acsele devuelve InteresPrestamo como tasa nominal mensual en porcentaje (ej. 0.8 = 0.8% mensual).
 */
export function parseTasaInteresMensual (valorApi) {
  const tasa = parseValorTasa(valorApi)
  return isNaN(tasa) ? 0 : tasa
}

export function formatearTasaInteresMensualDisplay (valorApi) {
  const tasa = parseValorTasa(valorApi)
  if (isNaN(tasa)) return String(valorApi) + '%'
  return tasa.toFixed(2) + '%'
}

export function formatearTasaInteresParaSolicitud (valorApi) {
  const tasa = parseValorTasa(valorApi)
  if (isNaN(tasa)) return String(valorApi)
  return tasa.toFixed(2)
}

export function formatearTeaDisplay (tea) {
  if (tea === null || tea === undefined || tea === '') {
    return TEA_PRESTAMO_VIDA_DISPLAY
  }
  const valor = parseValorTasa(tea)
  if (isNaN(valor)) return String(tea).includes('%') ? String(tea) : String(tea) + '%'
  const formateado = Number.isInteger(valor) ? String(valor) : valor.toFixed(2).replace(/\.?0+$/, '')
  return formateado + '%'
}

export function calcularPagoInteresMensual (monto, valorApi) {
  const montoNumerico = parseValorTasa(monto)
  const tasaMensual = parseTasaInteresMensual(valorApi)
  if (isNaN(montoNumerico) || montoNumerico <= 0 || tasaMensual <= 0) return 0
  return (montoNumerico * tasaMensual) / 100
}

export function formatearPagoInteresMensual (monto, valorApi) {
  return calcularPagoInteresMensual(monto, valorApi).toFixed(2)
}



// WEBPACK FOOTER //
// ./src/utils/prestamosVidaInteresUtil.js